module.exports = __webpack_public_path__ + "static/media/vehicle-small.515854f4.svg";